import React, { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { uploadDriverLicense, updateDriverLicenseInformation } from "helpers/fakebackend_helper";
import DriverLicenseFlow from "pages/Authentication/onboarding-steps/DriverLicenseFlow";
import heic2any from "heic2any";
import imageCompression from "browser-image-compression";
import { pdfjs } from "react-pdf";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function ManualUploadModal({
    isOpen,
    toggle,
    user,
    file,
    rawText,
    setRawText,
    preview,
    setPreview,
    reloadData
}) {
    const [uploading, setUploading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    const token = authUser?.token || "";

    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 2000,
            useWebWorker: true
        };

        try {
            return await imageCompression(file, options);
        } catch (err) {
            console.error("Compression failed", err);
            return file;
        }
    };

    const pdfToPng = async (file) => {
        const pdf = await pdfjsLib.getDocument(await file.arrayBuffer()).promise;
        const page = await pdf.getPage(1);

        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement("canvas");

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
            canvasContext: canvas.getContext("2d"),
            viewport
        }).promise;

        const blob = await new Promise((resolve) =>
            canvas.toBlob(resolve, "image/png")
        );

        return new File([blob], "converted.png", { type: "image/png" });
    };

    const convertHeic = async (file) => {
        if (!file.name.toLowerCase().endsWith(".heic")) return file;

        const blob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.9
        });

        return new File([blob], file.name.replace(/\.heic$/i, ".jpg"), {
            type: "image/jpeg"
        });
    };

    const uploadSignedDoc = async (e) => {
        let selected = e.target.files[0];
        if (!selected) return;

        setUploading(true);

        let processedFile = selected;

        // 1) PDF → PNG
        if (selected.type === "application/pdf") {
            processedFile = await pdfToPng(selected);
        }

        // 2) HEIC → JPG
        processedFile = await convertHeic(processedFile);

        // 3) Compress final image
        processedFile = await compressImage(processedFile);

        console.log("Final Upload File:", processedFile.name, processedFile.type, processedFile.size);

        const form = new FormData();
        form.append("file", processedFile);
        form.append("email", user.email);

        const resp = await uploadDriverLicense(token, form);

        if (resp.code === 1) {
            setRawText(resp.data);
            setPreview(URL.createObjectURL(processedFile));
            setShowForm(true);
        }

        setUploading(false);
    };

    const saveUpdatedDL = async (payload) => {
        const resp = await updateDriverLicenseInformation(token, payload.data);
        reloadData();
        toggle();
        return resp;
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            contentClassName="custom-dark-modal"
            style={{ maxWidth: 650 }}
        >
            <ModalBody
                style={{
                    background: "#262523",
                    padding: 30,
                    borderRadius: 12,
                    color: "white"
                }}
            >
                {!showForm && (
                    <>
                        <h3 style={{ color: "#ffd86b", textAlign: "center", marginBottom: 20 }}>Upload {file?.type}</h3>

                        <label
                            style={{
                                width: "100%",
                                maxWidth: 400,
                                padding: "1rem",
                                borderRadius: 12,
                                textAlign: "center",
                                background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
                                boxShadow:
                                    "4px 4px 12px rgba(0,0,0,0.12), -4px -4px 12px rgba(255,255,255,0.9)",
                                fontSize: "1.1rem",
                                fontWeight: 600,
                                color: "#333",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                display: "block",
                                margin: "0 auto"
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = "translateY(-2px)";
                                e.target.style.boxShadow =
                                    "6px 6px 16px rgba(0,0,0,0.15), -6px -6px 16px rgba(255,255,255,1)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow =
                                    "4px 4px 12px rgba(0,0,0,0.12), -4px -4px 12px rgba(255,255,255,0.9)";
                            }}
                        >
                            {uploading ? "Uploading..." : "Upload Driver License"}
                            <input
                                type="file"
                                accept="image/png, image/jpeg, application/pdf"
                                onChange={uploadSignedDoc}
                                style={{ display: "none" }}
                            />
                        </label>

                        <Button
                            color="secondary"
                            className="mt-3 w-100"
                            onClick={toggle}
                        >
                            Cancel
                        </Button>
                    </>
                )}

                {showForm && file?.type === "Driver License" && (
                    <DriverLicenseFlow
                        preview={preview}
                        rawText={rawText}
                        email={user.email}
                        onSubmit={saveUpdatedDL}
                        onRetake={() => {
                            setShowForm(false);
                            setPreview("");
                            setRawText("");
                        }}
                    />
                )}
            </ModalBody>
        </Modal>
    );
}